import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  private dataSource = new BehaviorSubject<any>(null); // Initial value
  resetData = this.dataSource.asObservable();

  baseUrl: string = environment.url;
  headers: HttpHeaders;

  constructor(private http: HttpClient) {
    const xTenantId = sessionStorage.getItem('locationCode') || '101'; // Default to '101' if not set
    const token = sessionStorage.getItem('token');

    if (!token) {
      console.warn('Authorization token is missing. Please ensure the user is logged in.');
    }

    this.headers = new HttpHeaders({
      Authorization: token || '', // Use an empty string if no token is available
      'X-TENANT-ID': xTenantId,
    });
  }

  /**
   * Updates the shared data value.
   * @param data - New data to be shared across components.
   */
  changeData(data: any): void {
    this.dataSource.next(data);
  }

  /**
   * Fetch CSV data from the given endpoint.
   * @param endPoint - API endpoint to fetch CSV data.
   * @returns Observable of the CSV data as a text response.
   */
  getCsvData(endPoint: string) {
    return this.http.get(`${this.baseUrl}${endPoint}`, {
      headers: this.headers,
      responseType: 'text',
    });
  }

  getArchivesDownloadData(endPoint: string, xTenantId: any = '101') {
    return this.http.get(`${this.baseUrl}${endPoint}`, {
      headers: this.headers.set('X-TENANT-ID', xTenantId),
      responseType: 'text',
    });
  }


  /**
   * Fetch data from the API using the provided endpoint.
   * @param endPoint - API endpoint to fetch data.
   * @returns Observable of the API response.
   */
  getApiData(endPoint: string) {
    return this.http.get(`${this.baseUrl}${endPoint}`, {
      headers: this.headers,
    });
  }

  getCsvList(params: any) {
    const endPoint = 'bankloanmis/admin/reportlist';
    const { xTenantId, ...queryParams } = params;

    const headersRequest = this.headers.set('X-TENANT-ID', xTenantId || sessionStorage.getItem('locationCode') || '101');

    // console.log('Query Params (without xTenantId): ', queryParams);

    return this.http.get(`${this.baseUrl}${endPoint}`, {
      headers: headersRequest,
      params: queryParams,
    });
  }

}
